/**
 * A barra lateral lembra fixa ou recolhida entre recarregamentos (D-143, DS-549).
 *
 * ## No navegador, e não no perfil
 *
 * A escolha é de apresentação e vale por navegador, como a resposta 4 da triagem aceitou.
 * Gravá-la no `/me` custaria um PATCH a cada clique e um campo novo no contrato de
 * preferências, e preferência de servidor por gesto de tela é justamente o que a troca de
 * entidade ensinou a evitar. O prefixo `dv:` é o do que o app já guarda no navegador (a busca
 * global, `componentes/busca-global.tsx`).
 *
 * ## Só no gesto, e "aberta" não deixa rastro
 *
 * Quem grava é o gesto (o botão do cabeçalho, o do topo da barra que espia, o toque num
 * grupo), nunca um efeito de montagem: quem nunca alternou a barra não deixa rastro no
 * navegador. Aberta é o padrão, então fixar aberta APAGA a chave em vez de gravar outra.
 *
 * ## O armazenamento pode não existir
 *
 * Em modo privado ou por política da empresa, o próprio acesso a `window.localStorage`
 * lança. Por isso quem chama passa um ACESSOR, e as duas funções o chamam dentro do `try`: a
 * leitura cai em "aberta", que é como a barra nasce, e a gravação vira silêncio (a escolha
 * vale até recarregar, e nada quebra a tela).
 */
export const CHAVE_DO_MENU_LATERAL = 'dv:menu-lateral'

const RECOLHIDO = 'recolhido'

/** A barra nasce recolhida? Só quando o navegador guardou "recolhido". */
export function lerMenuRecolhido(acessor: () => Pick<Storage, 'getItem'>): boolean {
  try {
    return acessor().getItem(CHAVE_DO_MENU_LATERAL) === RECOLHIDO
  } catch {
    return false
  }
}

/** Grava "recolhido", ou apaga a chave quando a barra é fixada aberta. Nunca lança. */
export function gravarMenuRecolhido(
  acessor: () => Pick<Storage, 'setItem' | 'removeItem'>,
  recolhido: boolean,
): void {
  try {
    const armazenamento = acessor()
    if (recolhido) armazenamento.setItem(CHAVE_DO_MENU_LATERAL, RECOLHIDO)
    else armazenamento.removeItem(CHAVE_DO_MENU_LATERAL)
  } catch {
    // Sem armazenamento, a escolha vale até recarregar.
  }
}
